import script from "./KMenuCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KMenuCard.vue?vue&type=script&setup=true&lang=js"

import "./KMenuCard.vue?vue&type=style&index=0&id=d8596bd4&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8596bd4"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
